import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { commonAPI } from 'api/commonAPI';
import { cloneDeep } from 'lodash';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { instructorApp } from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import { validUtil } from 'util/validUtil';
import AutoComplete
  from 'view/pages/InstructorApp/component/common/AutoComplete';
import InputItem from 'view/pages/InstructorApp/component/common/InputItem';
import { SpacingV } from 'view/pages/InstructorApp/component/common/Spacing';

const MembersStep1 = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    const email = useRef(null);
    const [renderItem, setRenderItem] = useState(false);
    const [instructorData, setInstructorData] = useRecoilState(instructorApp);
    const [jobList, setJobList] = useState([]);
    const [inputValue, setInputValue] = useState({
        "blogUrl.linkedin": "",
        "blogUrl.twitter": "",
        "blogUrl.website": "",
        email: "",
        firstName: "",
        jobTitle: "",
        lastName: "",
        password: "",
    });

    const onChangeInput = (state, value) => {
        setInputValue({
            ...inputValue,
            [state]: value,
        });
    };
    const getJobList = async () => {
        await commonAPI.getJobList(null).then((res) => {
            console.log("jobList", res);
            const list = cloneDeep(res?.data);
            setJobList(list);
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validUtil.checkEmailValidation(inputValue.email)) {
            email.current.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
        }else{
            goToStep()
        }
    };

    const goToStep = () => {
        let state = {
            step1:cloneDeep(inputValue),
            step2:null,
            step3:null
        };
        if(!isEmpty(location?.state?.step2)){
            state = {
                ...cloneDeep(state),
                step2:location?.state?.step2
            }        
        }
        if(!isEmpty(location?.state?.step3)){
            state = {
                ...cloneDeep(state),
                step3:location?.state?.step3
            }    
        }
        navigate("/instructor_application/step2",{
            state:cloneDeep(state)
        })
    }

    useEffect(() => {
        getJobList();
    }, []);

    useEffect(()=>{
        if(!isEmpty(instructorData)){
            setInputValue(cloneDeep(instructorData))
        }
    },[instructorData])

    useEffect(()=>{
        if(isEmpty(instructorData) && !isEmpty(location?.state?.step1)){
            setInputValue({
                ...location?.state?.step1
            })
        }
    },[instructorData, location?.state?.step1])

    useEffect(()=>{
        setTimeout(() => {
        setRenderItem(true)            
        }, 200);
    },[])

    return (
        <Container 
        className={renderItem ? "on" : ""}
        onSubmit={()=>{}}>            
            <SubTitle>
                <h2>1. Personal information</h2>
                <span>Required fields *</span>
            </SubTitle>
            <InputItem

                placeholder="First name*"
                value={props?.data?.firstName}
                onChange={(e) => {
                    
                }}
                required={true}
            />
            <SpacingV height={18} />
            <InputItem
                placeholder="Last name*"
                required={true}
                value={props?.data?.lastName}
                onChange={(e) => {
                }}
            />
            <SpacingV ref={email} height={18} />
            <InputItem
                placeholder="Email*"
                required={true}
                // warn={validUtil.checkEmailValidation(inputValue.email)}
                value={props?.data?.email}
                onChange={(e) => {
            
                }}
                warnningMessage={"Please enter a valid email"}
            />
            <SpacingV height={8} />
            <p>
                Your email address will be used for your Whoflex Instructor Account login once your
                application is accepted.
            </p>
            <SpacingV height={18} />
            <InputItem
                required={false}
                fontSize={14}
                value={""}
                onChange={(e) => {
                    // onChangeInput("password", e.target.value);
                }}
                type={"password"}
                placeholder="Password*"
            />
            <SpacingV height={8} />
            <p>
                The password will be used for your Whoflex Instructor Account login once your
                application is accepted.
            </p>
            <SpacingV height={18} />
            <AutoComplete options={cloneDeep(jobList)}
                value={props?.data?.aboutTheAuthor?.jobTitle}
                onChange={()=>{
            }} />
            <SpacingV height={18} />
            <InputItem
                value={props?.data?.blogUrl?.linkedin}
                onChange={(e) => {
                }}
                placeholder="Linkedin profile URL"
            />
            <SpacingV height={18} />
            <InputItem
                value={props?.data?.blogUrl?.twitter}
                onChange={(e) => {
                }}
                placeholder="Twitter URL"
            />
            <SpacingV height={18} />
            <InputItem
                value={props?.data?.blogUrl?.website}
                onChange={(e) => {
                }}
                placeholder="Website URL"
            />
            <SpacingV height={30} />
            <Next onClick={()=>{props?.onClickNext()}}>
                <button >NEXT</button>
            </Next>
        </Container>
    );
};
export default MembersStep1;

const Container = styled.form`
    display: block;
     transform: translateX(-50px);
    transition: all 0.2s;
    opacity: 0;
    &.on{
        opacity: 1;
        transform: none;
    }
    p {
        font-family: Arial;
        font-weight: 400;
        font-size: 14px;
        color: #666;
        line-height: 21px;
    }
`;
const SubTitle = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 17px;
    h2 {
        font-size: 20px;
        font-weight: 400;
        font-weight: 400;
        color: #333;
    }
    span {
        display: flex;
        color: #666;
        font-size: 12px;
    }
`;
const Next = styled.div`
    width: 50%;
    span,
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Arial;
        font-weight: 700;
        font-size: 15px;
        text-align: center;
        text-transform: uppercase;
        color: #fff;
        background: #e0c463;
        border-radius: 5px;
        width: 100%;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        border: 0;
        padding: 17.68px 12px;
        line-height: 1;
        cursor: pointer;
    }
`;
